import { theme } from 'antd';
import { PropsWithChildren, useMemo } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import type { DefaultTheme } from 'styled-components';

import { StyleComponentsInterface } from './style.interfaces';

interface StyledProviderProps extends PropsWithChildren {
  components: StyleComponentsInterface;
}

export const StyledProvider = ({ children, components }: StyledProviderProps) => {
  const { token } = theme.useToken();

  const styledTheme = useMemo<DefaultTheme>(
    () => ({
      ...token,
      fontWeightStrong: token.fontWeightStrong ?? 500,
      Title: components.Title!,
      Select: components.Select!,
      Menu: components.Menu!,
      Steps: components.Steps!,
      Sidebar: components.Sidebar!,
      Divider: components.Divider!,
      Button: components.Button!,
    }),
    [token, components],
  );

  return <StyledThemeProvider theme={styledTheme}>{children}</StyledThemeProvider>;
};
